import { DragLayer } from 'react-dnd-compat';
import ResizableDragHandle from './ResizableDragHandle';
import { RESIZABLE_REPLY_EDITOR_ID } from './ResizableThreadViewWrapper';
import styled, { css } from 'foundations-theming/utils';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDragLayer = styled.div.withConfig({
  displayName: "ResizableEditorPreview__StyledDragLayer",
  componentId: "sc-1wxetb6-0"
})(["position:absolute;top:0;bottom:0;right:0;left:0;z-index:1000;pointer-events:none;"]);
const StyledPreviewWrapper = styled.div.withConfig({
  displayName: "ResizableEditorPreview__StyledPreviewWrapper",
  componentId: "sc-1wxetb6-1"
})(({
  currentOffset,
  startOffset,
  maxEditorHeight,
  minEditorHeight
}) => {
  const windowHeight = window.innerHeight;
  const NavBarHeight = 44;
  const ThreadToolBarHeight = 60;
  const offset = Math.min(windowHeight - minEditorHeight, Math.max(windowHeight - maxEditorHeight, (currentOffset === null || currentOffset === void 0 ? void 0 : currentOffset.y) || 0));
  const heightAdjustment = NavBarHeight + ThreadToolBarHeight;
  return css(["cursor:ns-resize;position:absolute;top:0;left:0;right:0;bottom:0;z-index:100;width:100%;background:rgba(100,100,100,0.3);", " ", ""], (!currentOffset || !startOffset) && css(["display:none;"]), currentOffset && css(["transform:translate(0,", "px);"], offset - heightAdjustment));
});
class ReplyEditorResizePreview extends Component {
  render() {
    const {
      currentOffset,
      startOffset,
      item,
      maxEditorHeight,
      minEditorHeight
    } = this.props;
    if (!item || item.id !== RESIZABLE_REPLY_EDITOR_ID) {
      // we're not dragging yet
      return null;
    }
    return /*#__PURE__*/_jsx(StyledDragLayer, {
      children: /*#__PURE__*/_jsx(StyledPreviewWrapper, {
        startOffset: startOffset,
        currentOffset: currentOffset,
        maxEditorHeight: maxEditorHeight,
        minEditorHeight: minEditorHeight,
        children: /*#__PURE__*/_jsx(ResizableDragHandle, {
          isPreview: true
        })
      }, "resizabled-editor-preview")
    });
  }
}
ReplyEditorResizePreview.displayName = 'ReplyEditorResizePreview';
export default DragLayer(monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getClientOffset(),
  startOffset: monitor.getInitialClientOffset()
}))(ReplyEditorResizePreview);